import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsEnum, IsUUID } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { PedagogicContentState } from '../../../enums/content.enum'
import { Transform } from 'class-transformer'

/**
 * DTO pour filtrer les chapitres avec pagination offset
 */
export class ListChaptersQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: "Filtrer par ID d'établissement",
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de statut',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  statusId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de période',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  periodId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de propriétaire',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  ownerId?: string

  @ApiPropertyOptional({
    description: 'États à inclure dans les résultats (DRAFT, ACTIVE, ARCHIVED)',
    enum: PedagogicContentState,
    isArray: true,
    example: ['ACTIVE', 'ARCHIVED'],
  })
  @IsOptional()
  @Transform(({ value }: { value: string | string[] }) => (Array.isArray(value) ? value : [value]))
  @IsEnum(PedagogicContentState, { each: true })
  includeStates?: PedagogicContentState[]
}
